<template>
	<div class="product-options" data-print="disabled">
		<MdButton
			v-if="!isRequired"
			class="md-icon-button md-dense remove-product mobile-hide"
			@click="$emit('removeProduct')"
			><base-icon icon-name="add"
		/></MdButton>
		<div class="button-wrap" :id="isTabletView ? 'tour-step-alt' : 'tour-step1'">
			<MdButton
				v-if="!isRequired"
				class="md-primary md-border-primary md-button-large show-product-btn"
				@click="tourActive ? '#' : $emit('seeAllProducts')"
				data-test="see-all-products"
			>
				<span>see more options</span><span>{{ productsCount }}</span>
			</MdButton>
		</div>
	</div>
</template>
<script>
export default {
	name: 'ProductOptions',
	props: {
		productsCount: {
			type: Number,
		},
		tourActive: {
			type: Boolean,
			default: false,
		},
		isTabletView: {
			type: Boolean,
			default: false,
		},
		isRequired: {
			type: Boolean,
			default: false,
		},
	},
};
</script>
<style lang="scss">
.product-options {
	@media (min-width: $tablet) {
		padding-left: 20px;
		display: flex;
		align-items: center;
		flex: 1 1 350px;
		position: relative;
		border-left: 1px solid #e5eff9;
	}
	@media only screen and (min-width: $mobile+1) and (max-width: $tablet) {
		display: none;
	}
	.button-wrap {
		@media only screen and (max-width: $mobile) {
			text-align: center;
		}
		.md-button.md-primary.md-border-primary.md-button-large.show-product-btn.md-theme-default {
			@media only screen and (max-width: $mobile) {
				width: 100%;
				max-width: 296px;
				margin-bottom: 16px;
			}
			.md-ripple {
				padding: 0;
				.md-button-content {
					@media only screen and (min-width: $mobile+1) {
						@include flexRow;
						justify-content: space-between;
						align-items: center;
					}
					span:first-of-type {
						padding: 12px 33px;
					}
					/* see all products - text */
					span:nth-child(2) {
						background: $color-blue;
						border-radius: 0px 10px 10px 0px;
						position: relative;
						left: 1px;
						color: white;
						padding: 12px 18px;
						height: 100%;
						border-radius: 0px 5px 5px 0px;
						@media (max-width: $mobile) {
							left: 10px;
						}
					}
				}
			}
		}
	}
	.remove-product {
		opacity: 0;
		position: absolute;
		right: 0;
		top: 16px;
		.workflow-container-body:hover & {
			opacity: 1;
		}
	}
}
</style>
